export default "__VITE_ASSET__Dp9EIaPS__"